export default { translation: {
		name: 'Название',
		firstName: 'Имя',
		lastName: 'Фамилия',
		middleName: 'Отчество',
		fullName: 'Ф.И.О.',
		doubleClickToEdit: 'Двойной щелчок для редактирования',
		description: 'Описание',
		addDescription: 'Добавить описание',
		add: 'Добавить',
		// comment: 'Комментарий',
		finance: 'Финансы',
		information: 'Информация',
		attachments: 'Прикрепленные файлы',
		uploadFiles: 'Загрузить файлы',
		uploadingFiles: 'Загружаемые файлы',
		uploadError: 'Ошибка загрузки',
		uploadingFile: 'Загрузка файла',
		uploadSuccess: 'Загрузка завершена',
		rejectedFiles: 'Загрузка запрещена',
		selectedCount: 'Выбрано элементов',
		pagesCount: 'Страниц',
		dragDropHint: 'Перетащите сюда файлы или нажмите чтобы выбрать файлы',
		editHint: 'Двойной клик для редактирования',
		editHintMobile: 'Долгий тап для редактирования',
		management: 'Управление',
		sum: 'Сумма',
		tax: 'Налог',
		date: 'Дата',
		administration: 'Администрирование',
		usersAndRoles: 'Пользователи и права',
		settings: 'Настройки',
		percent: 'Процент',
		paid: 'Оплачено',
		phone: 'Телефон',
		create: 'Создать',
		search: 'Поиск',
		more: 'еще',
		moreEllipsis: 'Еще...',
		next: 'дальше',
		nextEllipsis: 'Дальше...',
		notFound: 'Не найдено',
		nothingFound: 'Ничего не найдено',
		total: 'всего',
		totalCount: 'записей',
		edit: 'Изменить',
		save: 'Сохранить',
		saving: 'Сохранение...',
		saved: 'Сохранено',
		savedAt: 'Сохранено в',
		cancel: 'Отмена',
		delete: 'Удалить',
		confirmDelete: 'Удалить?',
		deleting: 'Удаление...',
		deleted: 'Удалено',
		updatedAt: 'Обновлено',
		error: 'Ошибка',
		ok: 'ОК',
		yes: 'Да',
		projects: 'Проекты',
		dashboard: 'Управление',
		board: 'Задачи',
		agent: 'Агент',
		clients: 'Клиенты',
		persons: 'Персоны',
		budgets: 'Бюджеты',
		budgetRoles: 'Участники бюджетов',
		noSelected: 'не выбрано',
		noCreate: 'создание объекта здесь не разрешено',
		projectRoles: 'Роли в проектах',
		payments: 'Платежи',
		paymentInfo: 'Платежные реквизиты',
		realm: 'Область',
		status: 'Статус',
		color: 'Цвет',
		avatar: 'Аватар',
		priority: 'Приоритет',
		created: 'Создано',
		modified: 'Изменено',
		username: 'Пользователь',
		users: 'Пользователи',
		roles: 'Роли',
		acls: 'Права',
		perPage: 30,
		private: 'Приватность',
		startDate: 'Начало',
		dueDate: 'Завершение',
		roleMappings: 'Назначения ролей',
		authorization: 'Авторизация',
		login: 'Войти',
		logout: 'Выйти',
		AUTHORIZATION_REQUIRED: 'Необходимо авторизоваться',
		Unauthorized: 'Необходимо авторизоваться',
		required: 'Необходимо заполнить поле',
		placeholder: {
			search: 'Поиск...'
		},
		sign: {
			'in': 'Авторизация',
			'out': 'Выход',
		},
		password: {
			hint: 'Пароль...',
			field: 'Пароль',
			input: 'Введите пароль',
			new: 'Введите новый пароль',
			repeat: 'Повторите пароль',
			newHint: 'Оставьте поля пустыми, чтобы не менять пароль',
			empty: 'Введите пароль в оба поля',
			noMatch: 'Пароли не совпадают!',
			match: 'Пароли совпадают',
		},
		editor: {
			enterURL: 'Введите URL:',
			enterText: 'Введите текст для ссылки:',
		},
		file: {
			uploadFile: 'Загрузить файл',
			uploadFiles: 'Прикрепить файлы',
			uploadImage: 'Загрузить изображение',
			uploadStart: 'начинаю загрузку',
			uploading: 'загрузка файла...',
			uploadComplete: 'загрузка завершена',
			notSelected: 'файл не выбран',
			willBeUploaded: 'Будет загружен',
			wrongType: 'Неверный тип файла',
			upload: 'Загрузка',
		},
		validate: {
			empty: 'Пустое значение',
		}
	}
};
